import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchCrearLinkBitWarden = async (formData) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/bitwarden/crear-link`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;

  } catch (error) {
    handleAuthError(error);
    throw error;
  }
};